import gql from 'graphql-tag'
import {
    CreatePerformer,
    CreatePerformerMutation as CreateMutation,
    CreatePerformerMutationVariables as CreateMutationVariables,
    UpdatePerformer,
    UpdatePerformerMutation as UpdateMutation,
    UpdatePerformerMutationVariables as UpdateMutationVariables,
    DeletePerformerMutation as DeleteMutation,
    DeletePerformerMutationVariables as DeleteMutationVariables,
    MutationImportPerformersArgs,
    ImportResult
} from 'generated/graphql'
import graphql from 'utils/graphql'

// Create speaker
const createPerformerMutation = gql`
    mutation createPerformer($event:EventID!, $input: CreatePerformer!) {
        createPerformer(event: $event, data: $input) {
            id
            name
        }
    }
`
export const createSpeaker = (eventId, input: CreatePerformer) => {
    const query = graphql.createQuery<CreateMutation, CreateMutationVariables>(createPerformerMutation)
    return query({ event: eventId, input })
}

// Update speaker
const updatePerformerMutation = gql`
    mutation updatePerformer($id: Int!, $data: UpdatePerformer!) {
        updatePerformer(id: $id, data: $data) {
            id
        }
    }
`
export const updateSpeaker = (id, data: UpdatePerformer) => {
    const query = graphql.createQuery<UpdateMutation, UpdateMutationVariables>(updatePerformerMutation)
    return query({ id, data })
}

// Delete speaker
const deletePerformerMutation = gql`
    mutation deletePerformer($id: Int!) {
        deletePerformer(id: $id)
    }
`
export const deleteSpeaker = (id) => {
    const query = graphql.createQuery<DeleteMutation, DeleteMutationVariables>(deletePerformerMutation)
    return query({ id })
}

const importPerformersMutation = gql`
    mutation importPerformers($event: EventID!, $data: [ImportPerformer!]!) {
        importPerformers(event: $event, data: $data) {
            successCount
            errorCount
            errorItems {
                id
                message
                hiddenMessage
            }
        }
    }
`
export const importPerformers = ({ event, data }: MutationImportPerformersArgs) => {
    const query = graphql.createQuery<
        { importPerformers: ImportResult }, MutationImportPerformersArgs
    >(importPerformersMutation)
    return query({ event, data })
}
